import styled from 'styled-components';

export const ParagraphWrapper = styled.div`
  text-align: ${({ align }) => align || 'center'};
  font-size: ${({ fontSize }) => fontSize || '1.1rem'};
  margin: ${({ margin }) => margin || '1rem'};
  background-color: ${({ background }) => background || 'transparent'};
  color: ${({ color }) => color || '#444'};
  padding: ${({ padding }) => padding || '1rem 0'};

  @media (max-width: 768px) {
    font-size: ${({ fontSizeMobile }) => fontSizeMobile || '1rem'};
    margin: ${({ marginMobile }) => marginMobile || '0.75rem 1rem'};
    padding: ${({ paddingMobile }) => paddingMobile || '0.75rem 0'};
  }
`;